(function () {

  let showFaqBtns = document.querySelectorAll('[data-selector="show-faq"]');  

  showFaqBtns.forEach(function (showFaqBtn) {
    showFaqBtn.addEventListener('click', function () {
      this.parentElement.classList.toggle('faq__item_show')
    });
  });
})();